// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__h3bSa","content":"Footer_content__jvwg9","wrap":"Footer_wrap__R1kmH","copy":"Footer_copy__esABQ","links":"Footer_links__CLVyV","link":"Footer_link__NOh+Q"};